// src/Montaan/ModelBuilder/index.tsx

export * from './ModelBuilder';
export { default } from './ModelBuilder';
